"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orchestrateIntegrationConfiguration = exports.patchIntegrationConfiguration = exports.postIntegrationConfiguration = exports.getIntegrationConfigurationVersionsByUrl = exports.getIntegrationConfigurationVersionsById = exports.getIntegrationConfigurationByIdAndVersion = exports.getIntegrationConfigurationByUrl = exports.getIntegrationConfigurationById = exports.getIntegrationConfigurations = void 0;
const shared_1 = require("../models/shared");
const internalHelpers_1 = require("../internalHelpers");
const getIntegrationConfigurations = async (accessToken, options, env = shared_1.Env.PRODUCTION) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            offset: options === null || options === void 0 ? void 0 : options.offset,
            limit: options === null || options === void 0 ? void 0 : options.limit,
            includeArchived: options === null || options === void 0 ? void 0 : options.includeArchived
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurations = getIntegrationConfigurations;
const getIntegrationConfigurationById = async (accessToken, id, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations/${id}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurationById = getIntegrationConfigurationById;
const getIntegrationConfigurationByUrl = async (accessToken, url, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurationByUrl = getIntegrationConfigurationByUrl;
const getIntegrationConfigurationByIdAndVersion = async (accessToken, id, version, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations/${id}/versions/${version}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurationByIdAndVersion = getIntegrationConfigurationByIdAndVersion;
const getIntegrationConfigurationVersionsById = async (accessToken, id, options, env = shared_1.Env.PRODUCTION) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations/${id}/versions`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            offset: options === null || options === void 0 ? void 0 : options.offset,
            limit: options === null || options === void 0 ? void 0 : options.limit
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurationVersionsById = getIntegrationConfigurationVersionsById;
const getIntegrationConfigurationVersionsByUrl = async (accessToken, url, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(url + '/versions', {
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            offset: options === null || options === void 0 ? void 0 : options.offset,
            limit: options === null || options === void 0 ? void 0 : options.limit
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getIntegrationConfigurationVersionsByUrl = getIntegrationConfigurationVersionsByUrl;
const postIntegrationConfiguration = async (accessToken, ic, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.post(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations`, ic, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.postIntegrationConfiguration = postIntegrationConfiguration;
const patchIntegrationConfiguration = async (accessToken, patchDocument, integrationConfigurationId, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.patch(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations/${integrationConfigurationId}`, patchDocument, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.patchIntegrationConfiguration = patchIntegrationConfiguration;
const orchestrateIntegrationConfiguration = async (accessToken, orchestrateRequest, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.post(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations:orchestrate`, orchestrateRequest, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.orchestrateIntegrationConfiguration = orchestrateIntegrationConfiguration;
